module.exports = __webpack_public_path__ + "img/imagen7.bc90b903.png";